import { apiRequest } from '../../api-client';

export interface DeleteAdminSubscriptionParams {
  token: string;
  enterpriseId: string;
  subscriptionId: string;
  force?: boolean;
}

/**
 * Permanently delete a subscription from an enterprise.
 * DELETE /api-internal/enterprise/:enterprise_id/subscriptions/:subscription_id
 */
export async function deleteAdminSubscription({
  token,
  enterpriseId,
  subscriptionId,
  force
}: DeleteAdminSubscriptionParams): Promise<void> {
  const query = force ? '?force=true' : '';
  await apiRequest({
    method: 'DELETE',
    endpoint: `/api-internal/enterprise/${enterpriseId}/subscriptions/${subscriptionId}${query}`,
    token
  });
}
